export const Otbreportpayload = {
  "CorporationIDLst": "string",
  "PCIdLst": "",
  "ShortFromDate": "2026-01-10",
  "ShortToDate": "2026-01-10",
  "PickUpDays": 0,
  "Date": true,
  "DOW": true,
  "TotalRooms": false,
  "TrnsRooms": false,
  "GrpRooms": false,
  "OTBRoomsSold": true,
  "OTBOcc": false,
  "OTBADR": false,
  "OTBRoomRev": false,
  "OTBRevPar": false,
  "PickUpRooms": true,
  "PickUpADR": true,
  "PickUpRev": false,
  "PickUpOcc": false,
  "BudgetRoomsSold": true,
  "BudgetOcc": true,
  "BudgetAdr": false,
  "BudgetRoomRev": false,
  "BudgetRevPar": false,
  "RoomsSoldVariance": true,
  "ADRVariance": true,
  "RoomRevenueVariance": false,
  "OccVariance": false,
  "LYRoomsSold": true,
  "LYOccupancy": true,
  "LYADR": false,
  "LYRoomRev": false,
  "LYRevPar": false,
  "LYRoomsSoldVariance": true,
  "LYADRVariance": true,
  "LYRoomRevenueVariance": false,
  "LYOccVariance": true
};
